import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestAddMemberToTeam, requestRemoveMemberFromTeam } from './team-member.actions';
import { getAddMemberToTeamRequest, getRemoveMemberFromTeamRequest } from './team-member.endpoints';
import { ADDING_MEMBER_TO_TEAM, REMOVING_MEMBER_FROM_TEAM } from './team-member.constants';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { addMemberToTeam, removeMemberFromTeam } from '../../slices/programme/team/team.slice';

import { SUCCESS, ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performAddMemberToTeamRequest({ payload }) {
  const { teamExternalReference, memberExternalReference, onSuccess } = payload;

  try {
    yield put(addSpinner(ADDING_MEMBER_TO_TEAM));

    const request = getAddMemberToTeamRequest(teamExternalReference, memberExternalReference);

    const { data } = yield call(axios, ...request);

    yield put(
      addMemberToTeam({
        member: data.teamMember,
        teamExternalReference
      })
    );

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(ADDING_MEMBER_TO_TEAM));
  }
}

export function* watchForAddMemberToTeamRequest() {
  yield takeLatest(requestAddMemberToTeam.type, performAddMemberToTeamRequest);
}

export function* performRemoveMemberFromTeamRequest({ payload }) {
  const { teamExternalReference, memberExternalReference, onSuccess } = payload;

  try {
    yield put(addSpinner(REMOVING_MEMBER_FROM_TEAM));

    const request = getRemoveMemberFromTeamRequest(teamExternalReference, memberExternalReference);

    const { data } = yield call(axios, ...request);

    yield put(
      removeMemberFromTeam({
        teamExternalReference,
        memberExternalReference
      })
    );

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(REMOVING_MEMBER_FROM_TEAM));
  }
}

export function* watchForRemoveMemberFromTeamRequest() {
  yield takeLatest(requestRemoveMemberFromTeam.type, performRemoveMemberFromTeamRequest);
}

export default function* teamMemberSaga() {
  yield all([watchForAddMemberToTeamRequest(), watchForRemoveMemberFromTeamRequest()]);
}
